import { render } from "./EditTutorial.vue?vue&type=template&id=09761aaf&ts=true"
import script from "./EditTutorial.vue?vue&type=script&lang=ts"
export * from "./EditTutorial.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__